import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@awesome.me/kit-70c1f0055f/icons/classic/regular";
import type { RuleCitationSnapshot } from "@/services/api/case-checking";

const CITATION_QUOTE_MAX = 300;

/** Verbatim document quotes backing a rule verdict (Anthropic citations from deep rule re-checks). */
export function RuleCitations({
  citations,
  documentName,
  testId,
}: {
  citations: RuleCitationSnapshot[];
  documentName: (documentId: string) => string | undefined;
  testId?: string;
}) {
  if (citations.length === 0) return null;
  return (
    <div className="mt-2 space-y-2" data-testid={testId}>
      <p className="text-[11px] font-medium uppercase tracking-wide text-slate-500">Quoted evidence</p>
      <ul className="space-y-2">
        {citations.map((citation, idx) => {
          const docName = documentName(citation.document_id) ?? citation.document_id;
          const fullQuote = citation.cited_text;
          const displayQuote =
            fullQuote.length > CITATION_QUOTE_MAX ? `${fullQuote.slice(0, CITATION_QUOTE_MAX - 1)}…` : fullQuote;
          return (
            <li key={`${citation.document_id}-${idx}`}>
              <blockquote
                className="border-l-2 border-slate-300 pl-2 text-slate-600 italic whitespace-pre-line dark:border-white/10 dark:text-slate-300"
                title={fullQuote}
              >
                {displayQuote}
              </blockquote>
              <p className="mt-1 flex items-center gap-1.5 text-[11px] text-slate-500">
                <FontAwesomeIcon icon={faFile} className="h-3 w-3 shrink-0" />
                <span className="truncate" title={docName}>
                  {docName}
                </span>
              </p>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
